import { formatPrice as format } from "asos-web-currency-formatter";

export const formatPrice = (language, currency, value) =>
  format(value, language, currency);
